<ng-container *ngIf="viewModel$ | async as viewModel">
  <p-dialog
    header="Search Customers"
    [visible]="viewModel.show"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '34rem' }"
    (visibleChange)="store.dispatch(actions.searchCustomersDialogClosed())"
  >
    <span class="p-input-icon-right search-input">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        placeholder="Name, email, phone, or company"
        [value]="viewModel.query"
        (input)="
          store.dispatch(
            actions.searchQueryChanged({
              query: $any($event.target).value || '',
            })
          )
        "
      />
    </span>
    <p-listbox
      [options]="viewModel.customers"
      optionLabel="name"
      [listStyle]="{ 'max-height': '250px', width: '100%' }"
      dataKey="id"
      [emptyMessage]="viewModel.emptyMessage"
      (onChange)="
        store.dispatch(
          actions.customerRowClicked({
            customer: $event.value.customer,
          })
        )
      "
    >
      <ng-template let-item pTemplate="item">
        <div class="customer-item">
          <span class="customer-name">{{ item.name }}</span>
          <span class="customer-email">{{ item.email || '--' }}</span>
        </div>
      </ng-template>
    </p-listbox>
  </p-dialog>
</ng-container>
